import CIQPage from "../components/templates/CQIPage"

export default function CIQ() {
  return <CIQPage />
}
